module.exports = __webpack_public_path__ + "vimeo-play-dfe7764b4fe444c3880736ac6131f5b4.png";


//////////////////
// WEBPACK FOOTER
// ./~/lightgallery/dist/img/vimeo-play.png
// module id = 919
// module chunks = 124